<template>
  <div id="bulletinList">bulletinList</div>
</template>

<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";
export default {
  mixins: [part],
  name: "bulletinList",
};
</script>

<style>
</style>